export const loginStyles = {
    rootContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh"
    },
    headerContainer: {
        height: '30% !important',
        textAlign: 'center', 
        borderBottom: '25px rgb(0, 139, 176) solid', 
        width: '100%'
    }
}